<template>
  <div :class="wrpCls">
    <a-space size="middle">
      <!-- 新增提示按钮-分销商分享 -->
      <a-button @click="showModal = true" v-show=inviteStatus>邀请下级代理商</a-button>
      <!-- 模态框 -->
      <a-modal
        :visible="showModal"
        title="分销商分享信息"
        @ok="showModal = false"
        @cancel="showModal = false"
      >
        <div v-if="loading">加载中...</div>
        <div v-else >{{inviteUrl}}</div>
      </a-modal>
      <!-- 新增提示按钮-用户分享 -->
      <a-button @click="showModal1 = true" v-show=inviteUserStatus>邀请普通用户</a-button>
      <a-button @click="showActive= true"  v-show="isActive=='0'">APP账号激活</a-button>
      <a-button @click="docflage= true"  v-show="isActive=='0'">APP账号激活说明文档</a-button>
      <!-- 模态框 -->
      <a-modal
        :visible="showModal1"
        title="用户分享信息"
        @ok="showModal1 = false"
        @cancel="showModal1 = false">
        <div v-if="loading">加载中...</div>
        <a v-else  @click="copyUrl(inviteUserUrl)">{{inviteUserUrl}}</a>
      </a-modal>


      <a-modal
        :visible="showActive"
        title="分销身份激活"
        @ok="activationAccount()"
        @cancel="showActive = false"
      >
        <a-form-model ref="form" :model="form">
          <a-form-model-item label="APP用户Id" >
            <a-input :disabled="isActive=='1'" :min="0" v-model="form.showId" placeholder="请输入APP用户Id" />
          </a-form-model-item>
        </a-form-model>
<!--        <div style="margin-top: 8px; text-align: left;">-->
<!--          <a @click="editActive()" style="font-size: 18px; cursor: pointer;">说明文档</a>-->
<!--        </div>-->
      </a-modal>

      <a-modal
        :visible="docflage"
        title="说明文档"
        @ok="docflage = false"
        @cancel="docflage = false"
      >
       <div disable="false" v-html="this.docParam"></div>
      </a-modal>
      <!--      <a-tooltip placement="bottom">-->
      <!--        <template slot="title">-->
      <!--          源码地址-->
      <!--        </template>-->
      <!--        <a-icon type="github" @click="toGithub" :style="{ fontSize: '20px' }"/>-->
      <!--      </a-tooltip>-->
      <!--      <a-tooltip placement="bottom">-->
      <!--        <template slot="title">-->
      <!--          文档地址-->
      <!--        </template>-->
      <!--        <a-icon type="question-circle-o" @click="toDoc" :style="{ fontSize: '20px' }"/>-->
      <!--      </a-tooltip>-->
      <screenfull />
      <!--      <notice-icon v-hasPermi="['system:notice:list']" style="cursor: pointer;"/>-->
      <avatar-dropdown :menu="showMenu" :current-user="currentUser" :class="prefixCls" />
      <!-- 暂只支持中文，国际化可自行扩展 -->
      <!-- <select-lang :class="prefixCls" /> -->
    </a-space>
  </div>
</template>

<script>
import AvatarDropdown from './AvatarDropdown'
import NoticeIcon from '@/components/NoticeIcon'
import Screenfull from '@/components/Screenfull'
import SelectLang from '@/components/SelectLang'
import Editor from '@/components/Editor'
import {distributorShare, pageDistributor,activationAccount} from '@/api/user/distributor'
export default {
  name: 'RightContent',
  components: {
    AvatarDropdown,
    NoticeIcon,
    Screenfull,
    Editor,
    SelectLang
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-global-header-index-action'
    },
    isMobile: {
      type: Boolean,
      default: () => false
    },
    topMenu: {
      type: Boolean,
      required: true
    },
    theme: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showMenu: true,
      docflage: false,
      docParam: '',
      isActive: 0,
      currentUser: {},
      form: {showId: null},
      docUrl: process.env.VUE_APP_BASE_API +'/doc',
      githubUrl: 'http://gitlab.niurenjianzhan.com/zhangxun/java-framework',
      showModal: false, // 控制模态框的显示与隐藏
      showModal1: false, // 控制模态框的显示与隐藏
      showActive: false, // 控制模态框的显示与隐藏
      apiData: [], // 存储从接口获取的数据
      loading: false, // 控制加载状态
      distributorType: "", // 分销商级别
      inviteUrl:"", // 分销商邀请链接
      inviteUserUrl:"", // 分销商邀请用户链接
      inviteStatus:false, // 分销商分享按钮-是否显示邀请按钮
      inviteUserStatus:false // 用户分享按钮-是否显示邀请按钮

    }
  },
  computed: {
    wrpCls () {
      return {
        'ant-pro-global-header-index-right': true,
        [`ant-pro-global-header-index-${(this.isMobile || !this.topMenu) ? 'light' : this.theme}`]: true
      }
    }
  },
  created () {
    this.getShareData()
  },
  mounted () {
    setTimeout(() => {
      this.currentUser = {
        name: 'RuoYi'
      }
    }, 1500)
  },
  methods: {
    copyUrl(url) {


      var textarea = document.createElement('textarea');
      textarea.style.position = 'fixed';
      textarea.style.opacity = 0;
      textarea.value = url;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      this.$message.success(
        '复制成功'
      )


    },
    activationAccount() {
      activationAccount(this.form).then(response => {
        if (response.code == 40000) {
          this.$message.error(
            response.message,
            3
          )
        } else {
          this.$message.success(
            '绑定成功',
            3
          )
        }

        this.showActive=false
      })
    },

    editActive(){
      this.showActive =false
      this.docflage =true

    },
    toDoc () {
      window.open(this.docUrl)
    },
    toGithub () {
      window.open(this.githubUrl)
    },
    /** 分销商分享信息 */
    getShareData () {
      this.loading = true
      distributorShare().then(response => {
        this.loading = false
        this.distributorType = response.data.type
        if(response.data.type === 0){

          // 一级分销商，2个分享按钮
          this.inviteStatus = true
          this.inviteUserStatus = true
        }else if(response.data.type === 1){
          // 一级分销商，1个分享按钮
          this.inviteUserStatus = true
        }
        this.inviteUrl = response.data.inviteUrl
        this.inviteUserUrl = response.data.inviteUserUrl
        this.docParam = response.data.docParam
        this.isActive = response.data.isActive

      })
    },
    toDocPage() {
      this.$router.push({ path: '/activation-doc' })
    },
  }
}
</script>
